export enum EGAActions {
  ERROR = 'error',
}
